<lib-form-field-container
    #anchor
    [isOptional]="isOptional"
    [hideErrors]="autocompleteTrigger ? autocompleteTrigger.panelOpen : false"
    [kind]="kindOverride"
    (fieldClicked)="Clicked($event)"
    (fieldTouched)="Touch($event)">
    <ng-content
        label
        select="[label]"></ng-content>
    <ng-content
        supportingText
        select="[supportingText]"></ng-content>
    <ng-content
        prefixText
        select="[prefixText]"></ng-content>
    <ng-content
        prefixIcon
        select="[prefixIcon]"></ng-content>
    <ng-content
        suffixText
        select="[suffixText]"></ng-content>
    <ng-content
        menu
        select="[menu]"></ng-content>
    <ng-content
        bottomMenu
        select="[bottomMenu]"></ng-content>
    <ng-container readOnly>
        <div class="wrapper-content">
            <ng-content select="[readOnly]"></ng-content>
        </div>
        <div
            class="default-content sb-select-preview"
            [innerHTML]="selectedItemHTML | trustHtml"></div>
    </ng-container>

    <div
        #selectTrigger
        class="sb-select-trigger"
        [ngClass]="{ 'paypal-fontmatch': kindOverride === FormContainerKind.PayPalStyleMatch }"
        [hidden]="userTyping || !selectedItem">
        @if (triggerTemplate) {
            <ng-container *ngTemplateOutlet="triggerTemplate; context: { $implicit: selectedItem }"></ng-container>
        } @else {
            <div [innerHTML]="selectedItemHTML | trustHtml"></div>
        }
    </div>

    <input
        #input
        [id]="formFieldID"
            [attr.aria-describedby]="formFieldID + '-description ' + formFieldID + '-error'"
                        [attr.aria-label]="ariaLabel || null"
                        [attr.aria-invalid]="formControl.isDirty && formControl.errors ? 'true' : null"
            [attr.aria-required]="formControl.isRequired"
        [ngStyle]="{ cursor: userTyping ? 'text' : 'default' }"
        [ngClass]="{ 'sb-select-input-hidden': !userTyping && selectedItem, 'paypal-fontmatch': kindOverride === FormContainerKind.PayPalStyleMatch }"
        [readonly]="!userTyping"
        [placeholder]="userTyping ? filterText : selectedItem ? '' : placeholderText"
        [formControl]="viewControl"
        [matAutocomplete]="auto"
        [matAutocompleteConnectedTo]="anchor?.origin!"
        (change)="$event.stopPropagation()" />

    <ng-container suffixIcon>
        <lib-icon-button
            [kind]="ButtonKind.FormField"
            [size]="ButtonSize.Large"
            [disabled]="isDisabled"
            [icon]="autocompleteTrigger && autocompleteTrigger.panelOpen ? Icon.Common.CaretUp : Icon.Common.CaretDown"
            (clicked)="TogglePanel()"
            [hidden]="userTyping"></lib-icon-button>
    </ng-container>

    <mat-autocomplete
        #auto="matAutocomplete"
        [hideSingleSelectionIndicator]="false"
        (opened)="PanelOpened()"
        (optionSelected)="Selected($event)"
        (optionActivated)="Activated($event)"
        (closed)="PanelClosed()">
        @if (resultSetEmpty) {
            <mat-option
                [ngClass]="{ 'paypal-fontmatch': kindOverride === FormContainerKind.PayPalStyleMatch }"
                [disabled]="true">
                <div i18n="@@CommonAutoCompleteNoResultsFound">No results found</div>
            </mat-option>
        } @else if (isOptional && !itemSelectedFromDropDown && (!userTyping || viewControl.value === '')) {
            <mat-option
                [ngClass]="{ 'paypal-fontmatch': kindOverride === FormContainerKind.PayPalStyleMatch }"
                [value]="''">
                <div class="scss-select-item-content mat-select-placeholder">
                    {{ placeholderText }}
                </div>
            </mat-option>
        }

        @for (groupItems of filteredItemsByGroup | async | keyvalue: keepOrder; track groupItems.key) {
            @if (!groupItems.key) {
                @for (item of groupItems.value; track item.value) {
                    @if (item.menuDivider == MenuDivider.Above) {
                        <mat-divider class="my-2"></mat-divider>
                    }
                    <mat-option
                        [attr.data-sb-qa]="item.qaTag"
                        [ngClass]="{ 'paypal-fontmatch': kindOverride === FormContainerKind.PayPalStyleMatch }"
                        [value]="identifierOf(item.value)">
                        <ng-container *ngTemplateOutlet="panelItem; context: { $implicit: item }"></ng-container>
                    </mat-option>
                }
            } @else if (groupItems.value.length) {
                <mat-optgroup
                    class="select-text"
                    [label]="groupItems.key.name">
                    @for (item of groupItems.value; track item.value) {
                        <ng-container>
                            @if (item.menuDivider == MenuDivider.Above) {
                                <mat-divider class="my-2"></mat-divider>
                            }
                            <mat-option
                                [attr.data-sb-qa]="item.qaTag"
                                [ngClass]="{ 'paypal-fontmatch': kindOverride === FormContainerKind.PayPalStyleMatch }"
                                [value]="identifierOf(item.value)">
                                <ng-container *ngTemplateOutlet="panelItem; context: { $implicit: item }"></ng-container>
                            </mat-option>
                        </ng-container>
                    }
                </mat-optgroup>
            }
        }
    </mat-autocomplete>
</lib-form-field-container>

<ng-template
    #panelItem
    let-item>
    <div class="sb-panel-item-wrapper">
        <div class="sb-select-label-content"><ng-container *ngTemplateOutlet="item.selectLabel"></ng-container></div>
        <small class="sb-panel-supporting-text" #caption [hidden]="!caption.textContent?.trim()"><ng-container *ngTemplateOutlet="item.selectSupportingText"></ng-container></small>
    </div>
</ng-template>